import { Card, CardContent, Typography } from "@mui/material";
import styles from "./Components.module.css";

export default function SidebarCard({
  title,
  color = "#667eea",
  showDot = true,
  badge,
  children,
}: {
  title: string;
  icon?: React.ReactNode;
  color?: string;
  showDot?: boolean;
  badge?: React.ReactNode;
  children: React.ReactNode;
}) {
  return (
    <Card elevation={0} className={styles.card}>
      <div className={styles.cardHeader}>
        {showDot && <div className={styles.cardDot} style={{ backgroundColor: color }} />}
        <Typography variant="caption" className={styles.cardTitle}>
          {title}
        </Typography>
        {badge}
      </div>
      <CardContent className={styles.cardContent}>{children}</CardContent>
    </Card>
  );
}
